import {
  userConfig,
  auth,
  getUserInfo,
  updatePassword,
} from "@/api/user";
import {setToken,getToken,localSave,localRead,setBase64Token,getBase64Token} from "@/libs/util";

export default {
  state: {
    userName: '',
    password: '',
    userId: '',
    sys_user_id: '',
    avatarImgPath: '',
    token: getToken(),
    access: '',
    left: '',
    right: '',
    lpd: '',
    rpd: '',
    SIPControl: '',
    serverIp: '',
    sysLogin: false,
    control: '1',//1 左话机 2 右话机
    hasGetInfo: false,
    roleModule: [],//后台菜单权限
    lic: '',
    homeName: '',
    displayNum: '',
    defaultindex: 1,
    btnAccess: '',
    userAuth: getBase64Token(),
    role: '',
    hasCotrolOrConfRole: false,//是否含有主控台/会议室权限，控制终端行列数是否显示
    dept_id: '',//分区id
    is_admin: '',//是否管理员
    hiddenMenu: '',//隐藏的菜单
    menuOrder: '',//菜单顺序
    showDeviceAlarm: '',//终端报警
    broadcastMode: '',//系统类型。 1-呼叫 0-组播
    systemRole: '',//用户是否拥有control模块权限
    videoConf: 0,//大于0表示支持视频会议。
    haveVoiceConf:false,//是否拥有会议室授权
    videoSystemIp: null,//视频会议系统ip
    videoSystemPort: null,//视频会议系统端口。
    videoSystemKey: null,//视频会议系统密钥。
    videoShowTimeOut: 300,
    mapGis: false,
    webWarnVoice: null,
    cameraId: null,
    micId: null,
    speakId: null,
    remindCloseTime: 2,
    enableRemind: '0',
    isUnattended: '',
    isDispatch: false,
    haveChannel: false,
    isRate: 0,
    enableSrs: false,
    sipPort: 7066,
    sipsPort: 7067
  },
  mutations: {
    setEnableSrs(state, enableSrs) {
      state.enableSrs = enableSrs;
    },
    setSipPort(state, sipPort) {
      state.sipPort = sipPort
    },
    setSipsPort(state, sipsPort) {
      state.sipsPort = sipsPort
    },
    setVideoShowTimeOut(state, videoShowTimeOut) {
      state.videoShowTimeOut = videoShowTimeOut
    },
    setCameraId(state, cameraId) {
      state.cameraId = cameraId
    },
    setMicId(state, micId) {
      state.micId = micId
    },
    setSpeakId(state, speakId) {
      state.speakId=speakId
    },
    setSystemRole(state,systemRole){
      state.systemRole = systemRole
    },
    setHiddenMenu(state,menu){
      state.hiddenMenu = menu
    },
    setMenuOrder(state,menu){
      state.menuOrder = menu
    },
    setDept_id(state, dept_id) {
      state.dept_id = dept_id
    },
    setIs_admin(state, is_admin) {
      state.is_admin = is_admin
    },
    setHasCotrolOrConfRole(state, hasCotrolOrConfRole) {
      state.hasCotrolOrConfRole = hasCotrolOrConfRole
    },
    setAvatar(state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    setUserAuth(state, userAuth) {
      state.userAuth = userAuth
      setBase64Token(userAuth)
    },
    setDisplayNum(state, displayNum) {
      state.displayNum = displayNum
    },
    setShowDeviceAlarm(state, showDeviceAlarm) {
      state.showDeviceAlarm = showDeviceAlarm
    },
    setBroadcastMode(state, broadcastMode) {
      state.broadcastMode = broadcastMode
    },
    setVideoConf(state, videoConf) {
      state.videoConf = videoConf
    },
    setVideoSystemIp(state, videoSystemIp) {
      state.videoSystemIp = videoSystemIp
    },
    setVideoSystemPort(state, videoSystemPort) {
      state.videoSystemPort = videoSystemPort
    },
    setVideoSystemKey(state, videoSystemKey) {
      state.videoSystemKey = videoSystemKey
    },
    setWebWarnVoice(state, webWarnVoice) {
      state.webWarnVoice = webWarnVoice
    },
    setIsUnattended(state, isUnattended) {
      state.isUnattended = isUnattended
    },
    setIsRate(state, isRate) {
      state.isRate = isRate
    },
    setHaveVoiceConf(state, haveVoiceConf) {
      state.haveVoiceConf = haveVoiceConf
    },

    setLic(state,lic) {
      /**
       * @description 路由需要lic控制
       * @name              @index
       * monitor              0
       * action_plan&alarm    1
       * station              2
       * broadcast            5
       * conference           7
       * control              8
       *
        **/
      //yes;yes;yes;20;yes;yes;no;yes;yes;yes

      //console.log("lic:>>>"+lic)
      localSave('menu', lic);//菜单权限
      state.lic = lic;
      if (lic) {
        let arr = lic.split(';')
        let accessA=[]
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]==='yes'){
            if(i===0){
              accessA.push('monitor')
            }
            if(i===1){
              accessA.push('action_plan')
              accessA.push('alarm')
            }
            if(i===2){
              accessA.push('station')
            }
            if (i===5){
              accessA.push('broadcast')
            }
            if (i===7 || state.videoConf > 0){
              accessA.push('conference')
              state.haveVoiceConf = true
            }
            if (i===8){
              accessA.push('control')
            }
            if (i===25){
              accessA.push('cascade')
            }
            if (i===20){
              accessA.push('chatChannel')
              state.haveChannel = true;
            }
          }
          if (i === 2 && arr[i].toLowerCase() == 'gis') {
            accessA.push('station')
            state.mapGis = true
          }
          if (i === 15 && !(!isNaN(parseFloat(arr[i])) && isFinite(arr[i]))) {
            if (parseInt(arr[i]) > 0) {
              state.videoConf = parseInt(arr[i])
            }
          }
        }
        //兼容老license
        if (arr.length<9){
          accessA.push('control')
        }
        //判断是否是通讯调度
        state.isDispatch = state.mapGis || state.videoConf > 0

        //判断是否拥有对应的路由权限
        /******START*****/

        let role = localRead('role');
        let tempArr = role =='' ? [] : role.split(",")
        if (tempArr.indexOf("all_permissions.cascade") > -1) {//级联管理
          state.defaultindex = 1
          state.homeName = 'cascade'
          localSave('homeName', state.homeName);
          return;

        }
        if (tempArr.indexOf('all_permissions.communication_dispatching') > -1) {
          if (state.mapGis || state.videoConf > 0) {
            state.defaultindex = 15
            state.homeName = 'dispatch'
            localSave('homeName',state.homeName)
            return
          }
        }
        //匹配一级菜单
        if (tempArr.indexOf("all_permissions.main_console") > -1) {//主控台
          if (accessA.indexOf('control')>-1){
            //console.log("Has main_console lincense.....")
            state.defaultindex = 2
            state.homeName = 'control'
            localSave('homeName', state.homeName);
            return;
          }

        }

        if (tempArr.indexOf("all_permissions.conference_room") > -1) {//会议室
          if (accessA.indexOf('conference')>-1){
            //console.log("Has conference_room lincense.....")
            state.defaultindex = 3
            state.homeName = 'conference'
            localSave('homeName', state.homeName);
            return;
          }
      }
      if( tempArr.indexOf('all_permissions.broadcast_mission') > -1){//广播任务
        if (accessA.indexOf('broadcast')>-1){
          //console.log("Has broadcast lincense.....")
          state.defaultindex = 4
          state.homeName = 'broadcast'
          localSave('homeName', state.homeName);
          return;
        }

      }
      if(( tempArr.indexOf('all_permissions.alarm') > -1)){//报警
        if (accessA.indexOf('alarm')>-1){
          //console.log("Has alarm lincense.....")
          state.defaultindex = 6
          state.homeName = 'alarm'
          localSave('homeName', state.homeName);
          return;
        }

      }
      if(( tempArr.indexOf('all_permissions.video') > -1)){//视屏
        if (accessA.indexOf('monitor')>-1){
         // console.log("Has monitor lincense.....")
          state.defaultindex = 7
          state.homeName = 'monitor'
          localSave('homeName', state.homeName);
          return;
        }

      }
      if(( tempArr.indexOf('all_permissions.electronic_map') > -1)){//电子地图
        if (accessA.indexOf('station')>-1){
          //console.log("Has station lincense.....")
          state.defaultindex = 8
          state.homeName = 'station'
          localSave('homeName', state.homeName);
          return;
        }

      }
      if(( tempArr.indexOf('all_permissions.plan') > -1)){//预案
        if (accessA.indexOf('action_plan')>-1){
         // console.log("Has action_plan lincense.....")
          state.defaultindex = 9
          state.homeName = 'action_plan'
          localSave('homeName', state.homeName);
          return;
        }

      }
      if(( tempArr.indexOf('all_permissions.unattended') > -1)){//无人值守(无需license)

        state.defaultindex = 5
        state.homeName = 'unattended'
        localSave('homeName', state.homeName);

      return;

    }
    if(( tempArr.indexOf('all_permissions.scheduling_notification') > -1)){//调度通知(无需license)
      state.defaultindex = 10
      state.homeName = 'notice'
      localSave('homeName', state.homeName);
      return;

    }
    if(( tempArr.indexOf('all_permissions.contact') > -1)){//联系人(无需license)

      state.defaultindex = 11
      state.homeName = 'linkman'
      localSave('homeName', state.homeName);
      return;

    }
    if(( tempArr.indexOf('all_permissions.reported_information') > -1)){//上报信息(无需license)

      state.defaultindex = 14
      state.homeName = 'reporting_information'
      localSave('homeName', state.homeName);
      return;

    }
        if (tempArr.indexOf('all_permissions.chat') > -1) {
          if (state.haveChannel) {
            state.defaultindex = 33
            state.homeName = 'chatChannel'
            localSave('homeName',state.homeName)
            return
          }
        }
        if (tempArr.indexOf('all_permissions.report_form') > -1) {
          state.defaultindex = 20
          state.homeName = 'report'
          localSave('homeName',state.homeName)
          return
        }
   if(( tempArr.indexOf('all_permissions.system_administration') > -1)){//系统管理(无需license)
    return;
  }


        /*****END********/

      }
    },
    setBtnAccess(state, btnAccess) {
      localSave('role', btnAccess);//存储权限
      state.btnAccess = btnAccess
    },
    setUserId(state,id){
      state.userId = id
    },
    setSys_user_id(state,sys_user_id){
      state.sys_user_id = sys_user_id
    },
    setRoleModule(state,roleModule) {
      state.roleModule = roleModule
    },
    setUserName(state, name) {
      state.userName = name
    },
    setPassword(state,password) {
      state.password = password
    },
    setAccess(state, access) {
      state.access = access
    },
    setLeft(state,left) {
      state.left = left
    },
    setRight(state,right){
      state.right = right
    },
    setToken(state, token) {
      state.token = token
      setToken(token)
    },
    setBase64Token(state,token){
      state.base64Token = token
      setBase64Token(token)
    },
    setControl(state,control) {
      state.control = control
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    },
    setLpd(state, lpd) {
      state.lpd = lpd
    },
    setRpd(state, rpd) {
      state.rpd = rpd
    },
    setServerIp(state, serverIp) {
      state.serverIp = serverIp
    },
    setSysLogin(state, sysLogin) {
      state.sysLogin = sysLogin
    },
    setSIPControl(state, SIPControl) {
      state.SIPControl = SIPControl
    },
    setRemindCloseTime(state, remindCloseTime) {
      state.remindCloseTime = remindCloseTime
    },
    setEnableRemind(state, enableRemind) {
      state.enableRemind = enableRemind
    }
  },
  actions:{
    userLogin({commit}, {userName, password, code, toControl, success, fail, fastLogin}) {
      let form = {userAccount: userName, password, code ,fastLogin}
      auth(form).then(res => {
        let response = res.data
        let code = response.code
        if (code == 200) {
          commit('setToken', response.data.token)
          commit('setBase64Token',response.data.token)
          commit('setUserAuth', response.data.token)
          commit('setUserName', userName)
          commit('setPassword', password)
          sessionStorage.setItem('password', password)
          success(toControl, userName, response.data.token)
          if (response.timestamp) {
            sessionStorage.setItem('sysTime', response.timestamp + '')
          }
          return
        }

        fail(code,userName)
      }).catch()
    },
    async userConfig({commit}, {success, fail}) {
      await userConfig().then(res => {
        let response = res.data
        let code = response.code
        let config = response.data
        if (code != 200) {
          fail?fail(response):null
          return
        }
        if (response.timestamp) {
          sessionStorage.setItem('sysTime', response.timestamp + '')
          commit('setServerTime', response.timestamp + '')
        }
        //判斷有无license，或者是否过期
        if (!config.license) {
          fail ? fail(-100) : null;
          return;
        }
        let expire = config.expire;
        if (expire == 1) {
          fail ? fail(-101) : null
        }
        commit('setVideoConf', config.videoConf);
        commit('setVideoSystemIp', config.videoSystemIp)
        commit('setVideoSystemPort', config.videoSystemPort)
        commit('setVideoSystemKey', config.videoSystemKey)
        commit('setVideoShowTimeOut',config.videoShowTimeOut)
        commit('setIsRate', config.rate)
        commit('setBtnAccess', config.roles ? config.roles.join(',') : null)
        commit('setSystemRole', config.roles && config.roles.length > 0 ? true : false)
        localSave('menu', config.license)
        commit('setLic', config.license)
        commit('setLpd', config.lpd)
        commit('setRpd', config.rpd)
        commit('setServerIp', config.serverIp)
        commit('setSys_user_id', config.userId)
        commit('setSysLogin', true)
        commit('setSIPControl', config.sipPhone)
        if("2" === config.sipPhone){
          commit('setControl', "2")
        }else if("1" === config.sipPhone){
          commit('setControl', "1")
        }
        commit('setSipPort',config.sipPort)
        commit('setSipsPort',config.sipsPort)

        commit('setDisplayNum', config.displayNum)
        commit('setShowDeviceAlarm', config.showDeviceAlarm)
        commit('setBroadcastMode', config.broadcastMode)
        commit('setIs_admin', config.isAdmin)
        commit('setWebWarnVoice', config.webWarnVoice)
        commit('setIsUnattended', config.isUnattended)
        commit('setRemindCloseTime', config.remindCloseTime)
        commit('setEnableRemind', config.enableRemind)
        commit('setDept_id', config.deptId)
        commit('setAvatar', config.avatar)//undefined
        commit('setUserName', config.userAccount)
        commit('setUserId', config.userName)
        commit('setAccess', config.isAdmin==1)
        commit('setLeft', config.leftExten)
        commit('setRight', config.rightExten)
        commit('setHasGetInfo', true)
        commit('setWebVersion',config.version)
        commit('setEnableSrs',config.enableSrs)
        if(config.controlPhone){
          commit('setControl',config.controlPhone)
        }
        let password = sessionStorage.getItem('password')
        if (password) {
          commit('setPassword', password)
        }
        success ? success(config) : null
      })
    },
    updateUserAuth({state,commit},token){
      commit('setToken',token)
      commit('setBase64Token', token)
      commit('setUserAuth', token)
    },
    /*urlLogin({commit},{userName,password}){
      userName = userName.trim()
      return new Promise((resolve, reject) => {
        login({
          userName,
          password
        }).then(res=>{
          const data = res.data
          const status = data.code
          const userInfo = data.data
          if (status === 1000) {
            commit('setToken', data.extraData.token)
            commit('setPassword', userInfo.password)
            commit('setAvatar', data.avatar)//undefined
            commit('setUserName', userInfo.userId)
            commit('setUserId', userInfo.username)
            commit('setAccess', userInfo.isAdmin)
            commit('setLeft', userInfo.leftExten)
            commit('setRight', userInfo.rightExten)
            commit('setHasGetInfo', true)
            commit('setRoleModule', data.extraData.modules)
            let auth = userName+":"+password+":2"
            auth = base64Encode(auth)
            loginSys({auth}).then(res=>{
              const info = res.data
              if (info.statuscode === '000000') {
                commit('setVideoConf', info.videoConf)
                commit('setVideoSystemIp', info.videoSystemIp)
                commit('setVideoSystemPort', info.videoSystemPort)
                commit('setVideoSystemKey', info.videoSystemKey)
                commit('setIsRate',info.rate)

                commit('setBtnAccess', info.role)
                commit('setLic', info.lic)
                commit('setUserAuth', info.token)

                commit('setLpd', info.lpd)
                commit('setRpd', info.rpd)
                commit('setServerIp', info.serverip)
                commit('setSys_user_id', info.sys_user_id)
                commit('setSysLogin', true)
                commit('setSIPControl', info.sip_phone)

                commit('setDisplayNum', info.display_num)
                commit('setShowDeviceAlarm',info.show_device_alarm)
                commit('setBroadcastMode',info.broadcast_mode)
                if ((!info.role || info.role <= 0)) {
                  resolve('noRole')
                }
                let isAdmin = Number(info.is_admin)
                let deptId = Number(info.dept_id)
                commit('setIs_admin', isAdmin)

                commit('setWebWarnVoice',info.webWarnVoice)
                commit('setIsUnattended',info.isUnattended)
                commit('setRemindCloseTime',info.remindCloseTime)
                commit('setEnableRemind',info.enableRemind)
                if (isAdmin + '' === '1') {
                  deptId = '-1'
                }
                commit('setDept_id', deptId)

                let expire = info.expire
                if (expire === '0') {
                  resolve('expire')
                }
                resolve()
              } else {
                resolve(info.statuscode)
              }
            }).catch(err=>{
              resolve(err)
            })
          } else {
            resolve(data)
          }
        }).catch(err=>{
          reject(err)
        })
      })
    },*/
    handleLogOut({state,commit}){
      return new Promise((resolve, reject) => {
        commit('setToken','')
        commit('setAccess',[])
        resolve()
      })
    },
    getUserInfo({state, commit,dispatch}) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo().then(res=>{
            const data = res.data
            const status = data.code
            const userInfo = data.data
            if(status === 200){
              commit('setAvatar',data.avatar)//undefined
              commit('setUserName',userInfo.userId)
              commit('setUserId',userInfo.username)
              commit('setPassword',userInfo.password)
              commit('setAccess',userInfo.isAdmin)
              commit('setLeft',userInfo.leftExten)
              commit('setRight',userInfo.rightExten)
              commit('setHasGetInfo',true)
              commit('setRoleModule',data.extraData.modules)
              dispatch('userConfig')
            }else {
              resolve()
            }
          }).catch(err=>{
            reject(err)
          })
        }catch (error) {
          reject(error)
        }
      })
    },
    updatePassword({state,commit},{password,oldpassword}){
      return new Promise((resolve, reject) => {
        updatePassword(state.token,state.userName,password,oldpassword).then(res=>{
          const data = res.data
          resolve(data)
        }).catch(err=>{
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js